import { combineReducers } from "redux";
import users from "../features/admin/user-management/user/Slice";


const usermanagement = combineReducers({
    users: users
})


export default usermanagement;